// @flow

import {useState, useEffect, useCallback, useRef} from 'react';

import {checkIntersection} from './utils';


export const SCALED_ELEMENT_CLASS = 'scaled-element';

type OnDrag = (rect: ClientRect, event: any, shouldScale?: boolean) => void;

type UseElementScaling = (dragElement: ?Element, scaledElementClass?: string) => {onDrag: OnDrag };

export const useElementScaling: UseElementScaling = (dragElement, scaledElementClass = SCALED_ELEMENT_CLASS) => {
    const [size, setSize] = useState(0);
    const [inside, setInside] = useState(false);

    const selector = `.${scaledElementClass}`;

    const targetRef = useRef<?HTMLElement>(null);

    const onDrag: OnDrag = useCallback((rect, event, shouldScale = true) => {
        const targetEl = targetRef.current;

        if (event) {
            const {related, to} = event;
            targetRef.current = to;
            const elementSize = related.querySelector(selector)?.offsetWidth;

            if (elementSize) {
                setSize(elementSize);
            }
        }

        if (targetEl && rect.width) {
            setInside(checkIntersection(rect, targetEl.getBoundingClientRect()) && shouldScale);
        }
    }, [selector]);

    const scaleElement = useCallback(() => {
        const element = dragElement instanceof Element ? dragElement.querySelector(selector) : null;

        if (element instanceof HTMLElement) {
            if (size && inside) {
                element.style.transform = `scale(${size / (element.offsetWidth)})`;
            } else {
                element.style.transform = 'scale(1)';
            }
        }
    }, [dragElement, inside, selector, size]);

    useEffect(() => {
        scaleElement();
    }, [scaleElement]);

    return {onDrag};
};
